import React from "react";
import {
  FaEdit,
  FaFolderOpen,
  FaDownload,
  FaMousePointer,
  FaFolderPlus,
  FaUpload,
  FaCopy,
  FaArrowsAlt,
  FaPen,
  FaStar,
  FaMinusCircle,
  FaUserPlus,
  FaShareAlt,
  FaTrash
} from 'react-icons/fa';

const ContextMenu = ({ contextMenu, handleAction, closeMenu, activeTab }) => {
  if (!contextMenu) return null;

  const isEditable = (fileName) => {
    const ext = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
  
    switch (ext) {
      case ".pdf":
        return true;
      case ".doc":
      case ".docx":
        return true;
      case ".xls":
      case ".xlsx":
        return true;
      case ".ppt":
      case ".pptx":
        return true;
      default:
        return false;
    }
  };

  return (
    <div
      className="absolute bg-white dark:bg-gray-600 border border-gray-200 dark:border-gray-500 rounded shadow-md z-50"
      style={{ top: contextMenu.y, left: contextMenu.x, width: "158px" }}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className="py-1">
        {contextMenu.item === false ? <p/> : !contextMenu.selectionMode && contextMenu.item.type === "file" && isEditable(contextMenu.item.name) && (
          <button
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "edit"); closeMenu();}}
          >
            <FaEdit className="inline-block mr-2" /> Edit
          </button>
        )}
        {contextMenu.item === false ? <p/> : !contextMenu.selectionMode && contextMenu.item.type === "dir" && (
          <button
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "open"); closeMenu();}}
          >
            <FaFolderOpen className="inline-block mr-2" /> Open
          </button>
        )}
        {contextMenu.item === false ? <p/> : !contextMenu.selectionMode && (
          <button
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "download"); closeMenu();}}
          >
            <FaDownload className="inline-block mr-2" /> Download
          </button>
        )}
        {!contextMenu.selectionMode && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <button
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "select"); closeMenu();}}
          >
            <FaMousePointer className="inline-block mr-2" /> Select
          </button>
        )}
        {/* Create Folder Button */}
        {activeTab !== 'shared' && activeTab !== 'favorites' && (<button
          className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
          onClick={() => {handleAction(contextMenu, "create"); closeMenu();}}
        >
          <FaFolderPlus className="inline-block mr-2" /> Create Folder
        </button>)}
        {/* Upload File Button */}
        {activeTab !== 'shared' && activeTab !== 'favorites' && (<button
          className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
          onClick={() => {handleAction(contextMenu, "upload"); closeMenu();}}
        >
          <FaUpload className="inline-block mr-2" /> Upload file
        </button>)}
        {/* Copy Folder Button (only if a folder is selected) */}
        {contextMenu.item && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <button
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "copy"); closeMenu();}}
          >
            <FaCopy className="inline-block mr-2" /> Copy
          </button>
        )}
        {contextMenu.item && !contextMenu.selectionMode && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <button 
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "move"); closeMenu();}}
          >
            <FaArrowsAlt className="inline-block mr-2" /> Move
          </button>
        )}
        {contextMenu.item && !contextMenu.selectionMode && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <button 
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "rename"); closeMenu();}}
          >
            <FaPen className="inline-block mr-2" /> Rename
          </button>
        )}
        {contextMenu.item && !contextMenu.selectionMode && !contextMenu.item.favorite && activeTab !== 'shared' && (
          <button 
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "favorite"); closeMenu();}}
          >
            <FaStar className="inline-block mr-2" /> Favorite
          </button>
        )}
        {contextMenu.item && !contextMenu.selectionMode && contextMenu.item.favorite && activeTab !== 'shared' && (
          <button 
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "favorite"); closeMenu();}}
          >
            <FaMinusCircle className="inline-block mr-2" /> Unfavorite
          </button>
        )}
        {contextMenu.item && !contextMenu.selectionMode && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <button 
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "sharewithuser"); closeMenu();}}
          >
            <FaUserPlus className="inline-block mr-2" /> Share With
          </button>
        )}
        {contextMenu.item && !contextMenu.selectionMode && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <button 
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "share"); closeMenu();}}
          >
            <FaShareAlt className="inline-block mr-2" /> Share
          </button>
        )}
        {contextMenu.item && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <button 
            className="text-gray-600 dark:text-gray-200 block px-4 py-2 hover:bg-gray-100 hover:dark:bg-gray-900 w-full text-left"
            onClick={() => {handleAction(contextMenu, "delete"); closeMenu();}}  
          >
            <FaTrash className="inline-block mr-2" /> Delete
          </button>
        )}
      </div>
    </div>
  );
};

export default ContextMenu;